import React from 'react';
import './PillNavDemo.css';

const PillNavDemo = () => {
  return (
    <div className="pill-nav-demo">
      <div className="demo-content">
        <h1>PillNav Component Demo</h1>
        <p>This page demonstrates the enhanced PillNav component with improved visibility and functionality.</p>

        <div className="demo-section">
          <h2>Features</h2>
          <ul>
            <li>Enhanced visibility with glassmorphism effect</li>
            <li>Smooth animations and transitions</li>
            <li>Responsive design for all screen sizes</li>
            <li>Active state highlighting</li>
            <li>Hover effects with animated circles</li>
            <li>Mobile-friendly hamburger menu</li>
            <li>Scroll-aware navbar that shrinks on scroll</li>
          </ul>
        </div>

        <div className="demo-section">
          <h2>How It Works</h2>
          <p>The PillNav component uses GSAP for smooth animations and React Router for navigation. It automatically detects the current route and highlights the active navigation item.</p>

          <div className="code-example">
            <pre>
              {`<PillNav
  logo={logo}
  logoAlt="Company Logo"
  items={[
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Contact', href: '/contact' }
       { label: 'Blog', href: '/blog' }
  ]}
  className="custom-nav"
  baseColor="#95bad6"
  // baseColor="#cbb374" / "#95bad6" / "#ffffff"
  pillColor="#7C877F"
  hoveredPillTextColor="#FFFFFF"
  pillTextColor="#FFFFFF"
/>`}
            </pre>
          </div>
        </div>

        <div className="demo-section">
          <h2>Customization Options</h2>
          <p>The component is fully customizable with the following props:</p>
          <ul>
            <li><strong>logo</strong>: Path to your logo image</li>
            <li><strong>logoAlt</strong>: Alt text for accessibility</li>
            <li><strong>items</strong>: Array of navigation items with label and href</li>
            <li><strong>className</strong>: Additional CSS classes</li>
            <li><strong>baseColor</strong>: Background color of the navbar</li>
            <li><strong>pillColor</strong>: Background color of active/hovered pills</li>
            <li><strong>hoveredPillTextColor</strong>: Text color for hovered pills</li>
            <li><strong>pillTextColor</strong>: Default text color for pills</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PillNavDemo;